import { Tooltip, Box } from "@mui/material";
import { Star, TrackChanges, Link as LinkIcon } from "@mui/icons-material";
import { COR_DESCONTINUADO } from "constants/statusComponente";

interface BadgeIndicadorProps {
  tipo: "padrao" | "regraPorLinha" | "agrupamento";
  tamanho?: "small" | "medium";
  tooltip?: string;
  descontinuado?: boolean;
}

export const BadgeIndicador: React.FC<BadgeIndicadorProps> = ({ tipo, tamanho = "small", tooltip, descontinuado = false }) => {
  const getIcon = () => {
    switch (tipo) {
      case "padrao":
        return <Star sx={{ fontSize: tamanho === "small" ? 16 : 20, color: descontinuado ? COR_DESCONTINUADO : "#FFD700" }} />;
      case "regraPorLinha":
        return <TrackChanges sx={{ fontSize: tamanho === "small" ? 16 : 20, color: descontinuado ? COR_DESCONTINUADO : "#2E7D32" }} />;
      case "agrupamento":
        return <LinkIcon sx={{ fontSize: tamanho === "small" ? 18 : 22, color: descontinuado ? COR_DESCONTINUADO : "#2E7D32" }} />;
    }
  };

  const getTooltip = () => {
    if (tooltip) return tooltip;
    switch (tipo) {
      case "padrao":
        return "Aplicabilidade padrão definida";
      case "regraPorLinha":
        return "Regra específica por Linha/Sistema (prioridade sobre Padrão)";
      case "agrupamento":
        return "Agrupamento: 1→N ou N→1";
    }
  };

  return (
    <Tooltip title={getTooltip()} arrow>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "help",
        }}
      >
        {getIcon()}
      </Box>
    </Tooltip>
  );
};

